// extracted by mini-css-extract-plugin
export default {"ElementOperationOverlay":"ElementOperationOverlay_ElementOperationOverlay__rK-Cj","medium":"ElementOperationOverlay_medium__56bKK","low":"ElementOperationOverlay_low__FCzwe"};